<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="" name="0">
        <img src="/static/images/introduce-wlhy-1.png" >
      </el-tab-pane>
    </el-tabs>
    <div class="detail">晟易网络TMS系统于2008年推向市场，系统涵盖了从接收客户订单、泒车、电子协议签订、运输过程车辆跟踪、日常损失过程控制、与客户的运费及司机的运费结算、货款回收、油卡管理、ETC系统对接、日常财务收支、资金划拨、相关报表体系及相应的成本分析功能，为管理层提供了日常业务全流程监控提供了技术支持。</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeName: '0'
      }
    },
    mounted: function() {
      if (this.$global.getUrlKey("tab")) this.activeName = this.$global.getUrlKey("tab");
    }
  }
</script>

<style>
  .el-tabs__header {
    margin-bottom: 22px;
  }

  .el-tabs__nav-wrap:after {
    background-color: transparent;
  }

  .el-tabs__active-bar {
    width: 50px;
    height: 3px;
    background-color: #fff;
    border-radius: 1.5px;
  }

  .el-tabs__item {
    font-size: 16px;
    color: #e1e1e1;
  }

  .el-tabs__item.is-active,.el-tabs__item:hover {
    font-size: 18px;
    color: #fff;
  }

  .stance {
    height: 41px;
    margin-bottom: 22px;
  }

  .detail {
    margin-top: 25px;
    font-size: 14px;
    color: #e1e1e1;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/tms.vue